import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ContactRequestLayer from "../components/ContactRequestLayer";
import usePermission from "../hook/usePermission";
import AccessDeniedLayer from "../components/AccessDeniedLayer";

const ContactRequestPage = () => {
  // Using usersList permission as it is located under the Users module
  const hasPermission = usePermission("usersList", "view");
  
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Users" header="Contact Requests" />
        {hasPermission ? <ContactRequestLayer /> : <AccessDeniedLayer />}
      </MasterLayout>
    </>
  );
};

export default ContactRequestPage;
